/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Open_SocialInputs */

const cs_templates_open_social = /** @type {(inputs: Templates_Open_SocialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Použít`)
};

const en_templates_open_social = /** @type {(inputs: Templates_Open_SocialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use`)
};

/**
* | output |
* | --- |
* | "Use" |
*
* @param {Templates_Open_SocialInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_open_social = /** @type {((inputs?: Templates_Open_SocialInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Open_SocialInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_open_social(inputs)
	return cs_templates_open_social(inputs)
});